import api from '../api';

export const path = '/commercial/get';

export const getCommercialTypeRequest = () => api.get(`${path}/type`);

export const getCommercialMarkRequest = (type) =>
    api.get(`${path}/mark`, { params: { type } });

export const getCommercialModelRequest = (params) =>
    api.get(`${path}/model`, { params });

export const getCommercialBodyTypeRequest = (params) =>
    api.get(`${path}/bodyType`, { params });

export const getCommercialModificationRequest = (params) =>
    api.get(`${path}/modification`, { params });

export const getCommercialCharacteristicRequest = (params) =>
    api.get(`${path}/characteristic`, { params });

export const getCommercialTechDataRequest = (params) => {
    return api.get(`${path}/techData`, {
        params: { params },
    });
};
